export type FileUploadCopy = {
    fileSizeErrorMessage: string
    replacePdf: string
    uploadPdf: string
    uploadValuationPdf: string
    cancel: string
    valuationPdf: string
    dropDescription: string
    emptyTitle: string
    sampleButton: string
    sampleTooltip: string
    uploadTooltip: string
    restartAnalysis: string
    removeFile: string
}

export const DEFAULT_FILE_UPLOAD_COPY: FileUploadCopy = {
    fileSizeErrorMessage: 'Die Datei ist größer als 20 MB. Bitte PDF komprimieren und erneut versuchen.',
    replacePdf: 'PDF ersetzen',
    uploadPdf: 'PDF hochladen',
    uploadValuationPdf: 'Gutachten PDF hochladen',
    cancel: 'Abbrechen',
    valuationPdf: 'Gutachten PDF',
    dropDescription: 'Ziehe eine PDF hierher oder klicke zum Auswählen.',
    emptyTitle: 'Gutachten PDF hochladen',
    sampleButton: 'Mit Beispiel testen',
    sampleTooltip: 'Mit einwert Beispiel Gutachten testen.',
    uploadTooltip: 'Gutachten als PDF hochladen',
    restartAnalysis: 'Analyse erneut starten',
    removeFile: 'Datei entfernen',
}
